"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMatrixViewModel = useMatrixViewModel;
const react_1 = __importStar(require("react"));
const ramda_1 = require("ramda");
const attribute_header_cell_container_1 = require("../../cells/attribute-header-cell.container");
const use_matrix_data_hook_1 = require("../../client/hooks/use-matrix-data.hook");
const constants_1 = require("../../constants");
const build_category_structures_1 = require("../../utils/build-category-structures");
const utils_1 = require("../../utils/utils");
const table_styles_1 = require("../table.styles");
const localization_1 = require("../../../../localization");
function useMatrixViewModel({ selectedAttribute, selectedStrategyNodeId, selectedCatalogId, selectedProductTreeId, selectedL1Categories, selectedDisplayTable, onManageAttribute, }) {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const [mappingState, setMappingState] = react_1.default.useState(new Map());
    const [syntheticCellInfo, setSyntheticCellInfo] = react_1.default.useState(new Map());
    const { l1CategoriesData, terminalNodesDataForCellsAndAttributeValuesTotals, totalClassSkuCount, attributeValuesData, isLoading, error, } = (0, use_matrix_data_hook_1.useMatrixData)({
        selectedAttribute,
        selectedStrategyNodeId,
        selectedCatalogId,
        selectedProductTreeId,
        selectedL1Categories,
    });
    // TODO: will be redone in this ticket EN-4598
    let allL1Categories = [];
    if (selectedL1Categories.length === 0) {
        allL1Categories = (0, utils_1.createGroupedOptions)(l1CategoriesData).map((category) => (Object.assign(Object.assign({}, category), { allSelected: true })));
    }
    const categoriesToUse = selectedL1Categories.length === 0 ? allL1Categories : selectedL1Categories;
    const { childMap, productTitlesData } = (0, react_1.useMemo)(() => (0, build_category_structures_1.buildCategoryStructures)(categoriesToUse), [categoriesToUse]);
    const { flattenedData, flattenedDataMap } = (0, react_1.useMemo)(() => {
        var _a;
        const terminalNodesData = (_a = terminalNodesDataForCellsAndAttributeValuesTotals === null || terminalNodesDataForCellsAndAttributeValuesTotals === void 0 ? void 0 : terminalNodesDataForCellsAndAttributeValuesTotals.terminalNodesData) !== null && _a !== void 0 ? _a : [];
        const arr = terminalNodesData.map((node) => {
            var _a, _b;
            const child = childMap.get(node.terminalNodeId);
            const nodeTitle = (_a = child === null || child === void 0 ? void 0 : child.nodeTitle) !== null && _a !== void 0 ? _a : node.terminalNodeTitle;
            const key = (0, utils_1.getKey)(node.value, nodeTitle);
            return {
                nodeId: node.terminalNodeId,
                title: (_b = child === null || child === void 0 ? void 0 : child.nodeTitle) !== null && _b !== void 0 ? _b : node.terminalNodeTitle,
                attribute: selectedAttribute,
                value: node.value,
                applied: node.applied,
                parentTitle: child === null || child === void 0 ? void 0 : child.parentTitle,
                parentId: child === null || child === void 0 ? void 0 : child.parentId,
                isMapped: mappingState.has(key)
                    ? mappingState.get(key)
                    : node.applied !== undefined && node.applied >= 0,
            };
        });
        // Add mapped cells that are not in backend data
        // TODO: unmapped cells should be handled here as well
        mappingState.forEach((isMapped, key) => {
            if (isMapped && !arr.some((r) => (0, utils_1.getKey)(r.value, r.title) === key)) {
                const info = syntheticCellInfo.get(key) || {};
                arr.push({
                    nodeId: info.nodeId || '',
                    title: info.title || key.split('||')[1],
                    attribute: selectedAttribute,
                    value: info.value || key.split('||')[0],
                    applied: 0,
                    parentTitle: info.parentTitle || '',
                    parentId: info.parentId || '',
                    isMapped: true,
                });
            }
        });
        // all attribute values from attributeValuesData
        if (Array.isArray(attributeValuesData)) {
            attributeValuesData.forEach((edge) => {
                var _a;
                const attrValue = (_a = edge === null || edge === void 0 ? void 0 : edge.node) === null || _a === void 0 ? void 0 : _a.value;
                if (!arr.some((r) => r.value === attrValue)) {
                    arr.push({
                        nodeId: '',
                        title: '',
                        attribute: selectedAttribute,
                        value: attrValue,
                        applied: 0,
                        parentTitle: '',
                        parentId: '',
                        isMapped: false,
                    });
                }
            });
        }
        // Add attribute row entries to the map for each node title
        if (selectedAttribute) {
            productTitlesData.forEach((node) => {
                // Check if any cell for this specific attribute-node combination is mapped
                const isAttributeColumnMapped = arr.some((record) => record.title === node.title && record.isMapped);
                const key = (0, utils_1.getKey)(selectedAttribute, node.title);
                arr.push({
                    nodeId: '',
                    title: node.title,
                    attribute: selectedAttribute,
                    value: selectedAttribute,
                    applied: 0,
                    parentTitle: node.parentTitle,
                    parentId: node.parentId,
                    // Attribute cell is mapped only if: 1) the entire attribute has mapped values AND 2) this specific column has mapped values
                    isMapped: mappingState.has(key)
                        ? mappingState.get(key) : isAttributeColumnMapped,
                });
            });
        }
        const map = new Map();
        arr.forEach((r) => map.set((0, utils_1.getKey)(r.value, r.title), r));
        return { flattenedData: arr, flattenedDataMap: map };
    }, [
        terminalNodesDataForCellsAndAttributeValuesTotals,
        childMap,
        selectedAttribute,
        mappingState,
        syntheticCellInfo,
        attributeValuesData,
        productTitlesData,
    ]);
    const { displayedMatrixData, displayedProductTitles } = (0, react_1.useMemo)(() => {
        const rowMap = new Map();
        flattenedData.forEach((record) => {
            var _a;
            // Skip attribute row entries - they're handled separately in rowData
            if (record.value === selectedAttribute && record.title !== '') {
                return;
            }
            const row = (_a = rowMap.get(record.value)) !== null && _a !== void 0 ? _a : {
                value: record.value,
                byTitle: {},
                isMapped: false,
            };
            // A row should be mapped if ANY of its records are mapped
            row.isMapped = row.isMapped || record.isMapped;
            row.byTitle[record.title] = (row.byTitle[record.title] || 0) + record.applied;
            rowMap.set(record.value, row);
        });
        // Store original sets before filtering to avoid circular dependency
        const originalRows = [...rowMap.values()];
        const originalColumns = productTitlesData;
        let rows = originalRows;
        let columns = originalColumns;
        // Pre-compute mapped combinations for efficient filtering
        const mappedCombinations = flattenedData.reduce((acc, record) => {
            if (record.isMapped) {
                acc.add((0, utils_1.getKey)(record.value, record.title));
            }
            return acc;
        }, new Set());
        if (selectedDisplayTable.includes(utils_1.DisplayTableOption.HideEmptyColumns)) {
            // Show columns that have at least one mapped cell with any of the original rows
            columns = columns.filter((column) => originalRows.some((row) => mappedCombinations.has((0, utils_1.getKey)(row.value, column.title))));
        }
        if (selectedDisplayTable.includes(utils_1.DisplayTableOption.HideEmptyRows)) {
            // Show rows that have at least one mapped cell with any of the original columns
            rows = rows.filter((row) => originalColumns.some((column) => mappedCombinations.has((0, utils_1.getKey)(row.value, column.title))));
        }
        return { displayedMatrixData: rows, displayedProductTitles: columns };
    }, [flattenedData, productTitlesData, selectedDisplayTable, selectedAttribute]);
    const rowData = (0, react_1.useMemo)(() => {
        var _a, _b, _c;
        const totalCountMap = new Map((_b = (_a = terminalNodesDataForCellsAndAttributeValuesTotals === null || terminalNodesDataForCellsAndAttributeValuesTotals === void 0 ? void 0 : terminalNodesDataForCellsAndAttributeValuesTotals.totalProductsCount) === null || _a === void 0 ? void 0 : _a.map(({ dimensions: { value, attribute }, applied }) => [
            value !== null && value !== void 0 ? value : attribute,
            applied,
        ])) !== null && _b !== void 0 ? _b : []);
        // Sort displayedMatrixData by value (attribute value) alphabetically
        const sortedMatrixData = (0, ramda_1.sort)((0, ramda_1.ascend)((0, ramda_1.prop)('value')), displayedMatrixData);
        const rows = sortedMatrixData.map((row) => {
            var _a;
            const cell = {
                value: row.value,
                isMapped: row.isMapped,
            };
            displayedProductTitles.forEach((column) => {
                var _a;
                cell[column.title] = (_a = row.byTitle[column.title]) !== null && _a !== void 0 ? _a : 0;
            });
            cell.totalProductCount = (_a = (totalCountMap.get(row.value))) !== null && _a !== void 0 ? _a : 0;
            return cell;
        });
        if (selectedAttribute) {
            const columnTotals = {};
            displayedProductTitles.forEach((column) => {
                columnTotals[column.title] = rows.reduce((sum, row) => sum + (Number(row[column.title]) || 0), 0);
            });
            rows.unshift(Object.assign(Object.assign({ value: selectedAttribute, isMapped: true, isSelectedAttributeRow: true }, columnTotals), { totalProductCount: (_c = (totalCountMap.get(selectedAttribute))) !== null && _c !== void 0 ? _c : 0 }));
        }
        return rows;
    }, [
        displayedMatrixData,
        displayedProductTitles,
        terminalNodesDataForCellsAndAttributeValuesTotals,
        selectedAttribute,
    ]);
    const pinnedBottomRowData = (0, react_1.useMemo)(() => {
        var _a, _b, _c, _d, _e;
        if (!displayedProductTitles.length || !totalClassSkuCount)
            return [];
        const groupedTotals = (_e = (_d = (_c = (_b = (_a = totalClassSkuCount[0]) === null || _a === void 0 ? void 0 : _a.node) === null || _b === void 0 ? void 0 : _b.statistics) === null || _c === void 0 ? void 0 : _c.attributes) === null || _d === void 0 ? void 0 : _d.groupedTotals) !== null && _e !== void 0 ? _e : [];
        const skuMap = new Map(groupedTotals.map(({ dimensions: { productTreeNode }, applied }) => [
            productTreeNode === null || productTreeNode === void 0 ? void 0 : productTreeNode.title,
            applied,
        ]));
        const totalSkuCountRow = {
            field: constants_1.TOTAL_CLASS_SKU_COUNT_FIELD,
            value: '',
            totalProductCount: t({ key: 'TOTAL_CLASS_SKU_COUNT' }),
        };
        displayedProductTitles.forEach((column) => {
            var _a;
            totalSkuCountRow[column.title] = (_a = skuMap.get(column.title)) !== null && _a !== void 0 ? _a : 0;
        });
        return [totalSkuCountRow];
    }, [displayedProductTitles, t, totalClassSkuCount]);
    const columnDefs = (0, react_1.useMemo)(() => {
        const firstCol = {
            field: 'value',
            resizable: true,
            headerName: '',
            pinned: 'left',
            width: 180,
            cellRenderer: (p) => { var _a; return (((_a = p.data) === null || _a === void 0 ? void 0 : _a.isSelectedAttributeRow) ? (react_1.default.createElement(attribute_header_cell_container_1.AttributeHeaderCell, { attributeName: p.value, onManageAttribute: onManageAttribute })) : p.value); },
        };
        const totalCol = {
            field: constants_1.TOTAL_PRODUCT_COUNT_FIELD,
            headerName: t({ key: 'TOTAL_PRODUCT_COUNT' }),
            pinned: 'left',
            width: 200,
            valueFormatter: (p) => String((0, utils_1.formatValue)(p.value)),
        };
        const dynamic = displayedProductTitles.map(({ title, id, parentTitle }) => ({
            field: title,
            colId: id,
            headerComponent: () => (react_1.default.createElement(table_styles_1.HeaderContainer, null, react_1.default.createElement(table_styles_1.HeaderTitle, { title: title }, title), parentTitle && (react_1.default.createElement(table_styles_1.HeaderSubtitle, { title: `${t({ key: 'VIA' })} ${parentTitle}` }, `${t({ key: 'VIA' })} ${parentTitle}`)))),
            width: 180,
            valueFormatter: (p) => String((0, utils_1.formatValue)(p.value)),
            cellClass: (p) => {
                var _a, _b;
                return (((_b = flattenedDataMap.get((0, utils_1.getKey)((_a = p.data) === null || _a === void 0 ? void 0 : _a.value, title))) === null || _b === void 0 ? void 0 : _b.isMapped)
                    ? 'mapped-cell'
                    : 'unmapped-cell');
            },
        }));
        return [firstCol, totalCol, ...dynamic];
    }, [displayedProductTitles, flattenedDataMap, onManageAttribute, t]);
    const handleMappingChange = (0, react_1.useCallback)((key, isMapped, cellInfo) => {
        setMappingState((prevState) => {
            const newState = new Map(prevState);
            newState.set(key, isMapped);
            return newState;
        });
        if (isMapped && cellInfo) {
            setSyntheticCellInfo((prev) => {
                const newMap = new Map(prev);
                newMap.set(key, cellInfo);
                return newMap;
            });
        }
    }, []);
    return {
        isLoading,
        error,
        columnDefs,
        rowData,
        pinnedBottomRowData,
        flattenedDataMap,
        displayedProductTitles,
        handleMappingChange,
        setSyntheticCellInfo,
    };
}
